import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { catchError, tap } from 'rxjs/operators';
import { LegacyBookInitService } from 'modules/shared/legacy-bookexpress/services/legacy-book-initializer.service';
import { HttpService } from './http.service';
import { GetOfferApiResponse } from 'app/model/wbe/backend-api-response/get-offer-api-response';
@Injectable()
export class OfferlistService {
  private property_name: string;
  private server_name: string;
  private tenantId: any;
  private server_name_loyalty: string;
  private property_name_loyalty: string;
  public offerPreloader: boolean = true;
  public casinoPreloader: boolean = false;
  public errorMessage: string = '';
  private ArrivalDate: string = 'NA';
  private DepartureDate: string = 'NA';
  public assetsURL: string;
  public CloudDomainName: any;
  public locale: any;
  public serviceHeaders: any;
  constructor(
    private _http: HttpClient,
    private httpService: HttpService,
    private configservice: LegacyBookInitService,
    private router: Router
  ) {
    this.assetsURL = configservice.PropertyData.UrlMap.AssetsUrl;
    this.property_name = configservice.PropertyData.PropNameKeyList.offerlist;
    this.server_name = configservice.getserverDetails_offer();
    this.tenantId = configservice.gettenantId();
    this.server_name_loyalty = configservice.getserverDetails_loyalty();
    this.property_name_loyalty = configservice.PropertyData.PropNameKeyList.loyalty;
    this.CloudDomainName = configservice.getCloudDomainName();
    this.locale = this.configservice.langCode;
  }

  setValue(arrival, departure) {
    this.ArrivalDate = arrival;
    this.DepartureDate = departure;
  }

  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      console.error(error);
      //  this.router.navigate(["/wbe/maintenance/" + this.tenantId + '/' + this.property_name]);
      return of(result as T);
    };
  }

  casinoOffers(arrivalDate, departureDate, offerCode, CasinoNumber, CasinoTrigger): Observable<any[] | ArrayBuffer> {
    if (CasinoNumber) {
      if (!CasinoTrigger) {
        CasinoTrigger = '';
      }
    }
    this.setCasinoProloader();
    offerCode = encodeURIComponent(offerCode);
    let url;

    url =
      this.CloudDomainName +
      '/' +
      this.server_name +
      '/tenants/' +
      this.tenantId +
      ('/context/' + this.configservice.PropertyData.ContextId + '/') +
      'propertyName/' +
      this.property_name +
      '/nextOfferSequence/' +
      'NA' +
      '/arrivalDate/' +
      (arrivalDate || this.ArrivalDate) +
      '/departureDate/' +
      (departureDate || this.DepartureDate) +
      '/casinoAccountNumber/' +
      (CasinoNumber || 'NA') +
      '/casinoNumberRequired/' +
      (CasinoTrigger || 'NA') +
      '?appName=wbe&locale=' +
      this.locale +
      '&offer=' +
      (offerCode || 'NA');
    return this.httpService.get(url, this.configservice.serviceHeaders).pipe(
      tap((data) => console.log(data)),
      catchError(this.handleError('getOffers', []))
    );
  }
  private errorHandle = (error) => {
    // this.router.navigate(["/wbe/maintenance/" + this.tenantId + '/' + this.property_name]);
    console.log(error);
    this.errorMessage = error.ErrorMessage;
  };
  getOffers(
    nextSequence,
    totaloffers,
    offerCount,
    arrivalDate,
    departureDate,
    offerCode,
    CasinoNumber,
    CasinoTrigger
  ): Observable<GetOfferApiResponse> {
    this.setOfferProloader();
    offerCode = encodeURIComponent(offerCode);
    let url;

    url =
      this.CloudDomainName +
      '/' +
      this.server_name +
      '/tenants/' +
      this.tenantId +
      ('/context/' + this.configservice.PropertyData.ContextId + '/') +
      'propertyName/' +
      this.property_name +
      '/nextOfferSequence/' +
      nextSequence +
      '/arrivalDate/' +
      (arrivalDate || this.ArrivalDate) +
      '/departureDate/' +
      (departureDate || this.DepartureDate) +
      '/casinoAccountNumber/' +
      (CasinoNumber || 'NA') +
      '/casinoNumberRequired/' +
      false +
      '?appName=wbe&locale=' +
      this.configservice?.PropertyData?.langCode +
      '&offer=' +
      (offerCode || 'NA');
    if (nextSequence <= totaloffers) {
      return this.httpService.get(url).pipe(
        tap((data) => console.log(data)),
        catchError(this.handleError('getOffers', []))
      );
    }
    if (nextSequence > totaloffers) {
      return this.httpService.get(this.assetsURL + 'nodata.json', this.configservice.serviceHeaders).pipe(
        tap((data) => console.log(data)),
        catchError(this.handleError('getOffers', []))
      );
    }
  }

  setOfferProloader = function () {
    return this.offerPreloader;
  };
  setCasinoProloader = function () {
    return this.casinoPreloader;
  };

  getsingleOffers(
    nextSequence,
    totaloffers,
    offerCount,
    arrivalDate,
    departureDate,
    offerCode,
    CasinoNumber,
    CasinoTrigger
  ): Observable<GetOfferApiResponse> {
    offerCode = encodeURIComponent(offerCode);
    let url;
    url =
      this.CloudDomainName +
      '/' +
      this.server_name +
      '/tenants/' +
      this.tenantId +
      ('/context/' + this.configservice.PropertyData.ContextId + '/') +
      'propertyName/' +
      this.property_name +
      '/nextOfferSequence/' +
      'NA' +
      '/arrivalDate/' +
      (arrivalDate || this.ArrivalDate) +
      '/departureDate/' +
      (departureDate || this.DepartureDate) +
      '/casinoAccountNumber/' +
      (CasinoNumber || 'NA') +
      '/casinoNumberRequired/' +
      (CasinoTrigger || 'NA') +
      '?appName=wbe&locale=' +
      this.configservice?.PropertyData?.langCode +
      '&offer=' +
      (offerCode || 'NA');
    if (nextSequence <= totaloffers) {
      return this.httpService.get(url, this.configservice.serviceHeaders).pipe(
        tap((data) => console.log(data)),
        catchError(this.handleError('getOffers', []))
      );
    }
  }
  getgroupAllOffers(
    nextSequence,
    totaloffers,
    offerCount,
    arrivalDate,
    departureDate,
    offerCode,
    CasinoNumber,
    CasinoTrigger,
    groupCode
  ): Observable<any[] | ArrayBuffer> {
    offerCode = encodeURIComponent(offerCode);
    groupCode = encodeURIComponent(groupCode);
    let url;
    url =
      this.CloudDomainName +
      '/' +
      this.server_name +
      '/tenants/' +
      this.tenantId +
      ('/context/' + this.configservice.PropertyData.ContextId + '/') +
      'propertyName/' +
      this.property_name +
      '/nextOfferSequence/' +
      'NA' +
      '/arrivalDate/' +
      (arrivalDate || this.ArrivalDate) +
      '/departureDate/' +
      (departureDate || this.DepartureDate) +
      '/casinoAccountNumber/' +
      (CasinoNumber || 'NA') +
      '/casinoNumberRequired/' +
      (CasinoTrigger || 'NA') +
      `?groupCode=${groupCode}` +
      '&appName=wbe&locale=' +
      this.configservice?.PropertyData?.langCode +
      '&offer=' +
      (offerCode || 'NA');
    if (nextSequence <= totaloffers) {
      return this.httpService.get(url, this.configservice.serviceHeaders).pipe(
        tap((data) => console.log(data)),
        catchError(this.handleError('getOffers', []))
      );
    }
  }
}
